var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-page-title-dropdown"},[_c('div',{staticClass:"dp-page-title-dropdown__current"},[_vm._v(" "+_vm._s(_vm.titleText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }